import { styled } from "@mui/material/styles";
const drawerWidth = 240;

export const CustomLayout = styled('div')(({ theme }) => ({
  flexGrow: 1,
  minHeight: "100vh",
  zIndex: 1,
  overflow: "hidden",
  position: "relative",
  //this flex is breaking the table
  // display: 'flex',
  direction: theme.direction,
  fontFamily: theme.fontFamily,
  [theme.breakpoints.up("ss")]: {
    fontSize: theme.fontSizeSM,
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.fontSizeMD,
  },
  [theme.breakpoints.up("x3l")]: {
    fontSize: theme.fontSizeLG2,
  },
  // [theme.breakpoints.up("x4l")]: {
  //     fontSize: theme.fontSizeLG2,
  // },
  [theme.breakpoints.up("x5l")]: {
    fontSize: theme.fontSizeXL,
  },
}));

export const CustomMain = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  flexBasis: '100%',
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: theme.spacing(8.2),
  paddingBottom: theme.spacing(3),
  // backgroundColor: "#ffffff",
  // theme.palette.type === "light"
  //   ? theme.palette.newLight.secondary
  //   : theme.palette.newDark.secondary,
  // paddingLeft: theme.direction == 'ltr' ? closedAside + 35 : null,
  // paddingRight: theme.direction == 'rtl' ? closedAside + 35 : null,
  transition: theme.transitions.create("padding", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  minHeight: "92.7vh",
  [theme.breakpoints.up('ss')]: {
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(3),
  },
  [theme.breakpoints.up('sm')]: {
    paddingTop: theme.spacing(12.95),
    paddingBottom: theme.spacing(3),
    paddingLeft: '48px',
    paddingRight: '48px',
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(3),
  },
  [theme.breakpoints.up('xlDown')]: {
    paddingTop: theme.spacing(8.5),
    paddingBottom: theme.spacing(3),
  },
  [theme.breakpoints.up('xl')]: {
    paddingTop: theme.spacing(8.8),
    paddingBottom: theme.spacing(3),
  },
  // [theme.breakpoints.up('x3l')]: {
  //     paddingTop: theme.spacing(13.5),
  //     paddingBottom: theme.spacing(13.5),
  // },
  [theme.breakpoints.up('x5l')]: {
    paddingLeft: theme.spacing(25),
    paddingRight: theme.spacing(25),
  },
}));